import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const imgsBeam = createBeam(bifrost, "/web/imgs");
